<template>
  <div id="cover-spin">
    <span>
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      Chargement ...
    </span>
  </div>
  <div>
    <section class="contact py-5" id="contact">
      <div class="container py-lg-3">
        <h3 class="heading mb-5 text-center" data-aos="zoom-in">
          Entrer en contact avec nous
        </h3>
        <form @submit.prevent="sendEmail" data-aos="fade-up">
          <div class="row">
            <div class="col-md-6 styled-input mt-0">
              <input
                type="text"
                name="prenoms"
                v-model="commonObject.prenoms"
                placeholder="Prénoms"
                required="true"
              />
            </div>
            <div class="col-md-6 styled-input mt-md-0">
              <input
                type="text"
                name="nom"
                v-model="commonObject.nom"
                placeholder="Nom"
                required="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 styled-input">
              <input
                type="email"
                v-model="form.email"
                name="email"
                placeholder="Email"
                required="true"
              />
            </div>
            <div class="col-md-6 styled-input">
              <input
                type="text"
                name="whatsapp"
                v-model="commonObject.contact"
                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                placeholder="Votre Whatsapp"
                required="false"
              />
            </div>
          </div>
          <div class="styled-input">
            <textarea
              name="message"
              v-model="form.message"
              placeholder="entrez ici votre message"
              required="false"
            ></textarea>
          </div>
          <div class="click text-center mt-3">
            <input type="submit" value="Envoyer" />
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
/*import axios from "axios";*/
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import emailjs from "emailjs-com";

export default {
  name: "Contact-Item",
  data() {
    return {
      commonObject: {
        prenoms: "",
        nom: "",
        email: "",
        contact: "",
        message: "",
      },

      form: {
        title: "Mail LogikTech",
        name: "",
        time: new Date(),
        message: "",
        email: "",
      },
    };
  },
  props: {
    msg: String,
  },

  watch: {
    msg: {
      deep: true,
      handler(value) {
        this.form.message = value;
      },
    },
  },

  methods: {
    /*submitForm() {
      document.getElementById("cover-spin").style.visibility = "visible";
      this.commonObject.message = " "+this.commonObject.message+" ";
      axios
        .post("https://localhost:1307/microservices/send-mail", this.commonObject)
        .then(function (response) {
          console.clear();
          this.clearCommonObject();
          document.getElementById("cover-spin").style.visibility = "hidden";
          this.showToatInfo(response.data.message);
        }.bind(this))
        .catch(function (error) {
          console.log('here is the error -- > '+error);
          document.getElementById("cover-spin").style.visibility = "hidden";
          showToatError();
        }.bind(this));
    },*/

    sendEmail() {
      document.getElementById("cover-spin").style.visibility = "visible";
      this.form.name = this.commonObject.nom + ' ' + this.commonObject.prenoms;
      this.form.message = this.form.message + ' ' + this.commonObject.contact+' - '+this.form.email;
      emailjs
        .send(
          "service_2vinkxj",
          "template_8yg8vyo",
          this.form,
          "8KlaploLURmymcoQO" // ou public key
        )
        .then(() => {
          this.showToatInfo('Email envoyé avec succès !');
          this.form = { name: "", email: "", message: "" };
          this.commonObject = { nom: "", prenoms: "", contact: "" };
          document.getElementById("cover-spin").style.visibility = "hidden";
          console.clear();
        })
        .catch((error) => {
          showToatError();
          document.getElementById("cover-spin").style.visibility = "hidden";
        });
    },

    showToatError() {
      toast.error(
        "Problème de connexion. Veuillez réessayer ultérieurement !!!",
        {
          autoClose: 2000,
        }
      );
    },

    showToatInfo(retour) {
      toast.info(retour, {
        autoClose: 2400,
      });
    },

    clearCommonObject() {
      this.commonObject.message = "";
      this.commonObject.nom = "";
      this.commonObject.prenoms = "";
      this.commonObject.email = "";
      this.commonObject.contact = "";
    },

    loadingMessage(message) {
      this.commonObject.message = message;
      this.form.message = message;
    },
  },
};
</script>

<style scoped>
#cover-spin {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(83, 83, 83, 0.712);
  top: 0;
  left: 0;
  z-index: 99999000;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  color: #fff;
}
</style>